// src/pages/NotFound.jsx
import { Link } from "react-router-dom";
import Button from "../components/common/Button";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
      <div className="text-center max-w-lg mx-auto px-4">
        <h1 className="text-6xl font-bold text-vxdf-accent mb-4">404</h1>
        <p className="text-xl text-gray-300 mb-8">
          Oops! The page you&apos;re looking for doesn&apos;t exist.
        </p>
        <Link to="/">
          <Button variant="primary" size="lg">
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
